import { render, staticRenderFns } from "./Bots.vue?vue&type=template&id=47c0193e&scoped=true"
import script from "./Bots.vue?vue&type=script&lang=js"
export * from "./Bots.vue?vue&type=script&lang=js"
import style0 from "./Bots.vue?vue&type=style&index=0&id=47c0193e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0193e",
  null
  
)

export default component.exports